import React, { FC } from "react";

import { useGetMaintenanceByIdQuery } from "gql/generated/types";
import { Skeleton } from "primereact/skeleton";
import { TabPanel, TabView } from "primereact/tabview";
import { useParams } from "react-router-dom";
import { T } from "services/lang/LanguageService";
import { apolloErrorToaster } from "../../utils/utils";
import MaintenanceForm from "./MaintenanceForm";
import MaintenanceHistoryTable from "./MaintenanceHistoryTable";

const MaintenanceFormWrapper: FC = () => {
  const { maintenanceId } = useParams();

  const { data, loading } = useGetMaintenanceByIdQuery({
    variables: { id: maintenanceId! },
    skip: !maintenanceId,
    onError: apolloErrorToaster,
  });

  if (loading) return <MaintenanceFormSkeleton />;

  return (
    data?.maintenanceById && (
      <TabView className="col-12">
        <TabPanel header={T("mdm.maintenance")}>
          <MaintenanceForm maintenance={data.maintenanceById} />
        </TabPanel>
        <TabPanel header={T("mdm.status-history")}>
          <MaintenanceHistoryTable maintenance={data.maintenanceById} />
        </TabPanel>
      </TabView>
    )
  );
};

export default MaintenanceFormWrapper;

const MaintenanceFormSkeleton: FC = () => {
  return (
    <div className="flex flex-column gap-6 my-8 mx-3">
      <div className="flex flex-wrap justify-content-between mt-5">
        <Skeleton height="2.5rem" width="100%" />
      </div>
      <div className="flex flex-wrap justify-content-between">
        <Skeleton height="2.5rem" width="16%" />
        <Skeleton height="2.5rem" width="24%" />
        <Skeleton height="2.5rem" width="56%" />
      </div>
      <div className="flex flex-wrap justify-content-between">
        <Skeleton height="2.5rem" width="24%" />
        <Skeleton height="2.5rem" width="24%" />
        <Skeleton height="2.5rem" width="24%" />
        <Skeleton height="2.5rem" width="24%" />
      </div>
      <div className="flex flex-wrap justify-content-between">
        <Skeleton height="2.5rem" width="49%" />
        <Skeleton height="2.5rem" width="49%" />
      </div>
    </div>
  );
};
